export { FranchiseComponentSection } from './FranchiseComponentSection'
